import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/guards/auth';
import { NotificacionService } from 'src/app/services/service.index';
import { UtilHelper } from 'src/app/_helpers/util';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styles: []
})
export class HeaderComponent implements OnInit {

  isLogin: boolean = false;
  user: any = {};
  d: Date = new Date();
  year: number;
  loadAPI: Promise<any>;
  gestion: string = '';
  avisosNoRevisados: any[];
  totalAvisosNoRevisados: number = 0;
  pathAvatar: string = 'assets/img/profile.png';

  constructor(private _router: Router, public _as: AuthenticationService, private _ns: NotificacionService) {

  }

  ngOnInit() {
    this.gestion = 'GESTIÓN: ' + localStorage.getItem('g');
    this.year = this.d.getFullYear();
    this.user = JSON.parse(localStorage.getItem('u'));
    if (localStorage.getItem('u') != null) {   
      this.isLogin = true;
      this.cargarAvisosUsuarioPorUsuarioNoRev(this.user.id);
      this._ns.revisarNotificaciones(this.user.id, 0).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.totalAvisosNoRevisados = result.data.length;
            this.avisosNoRevisados = result.data;
          }
          else {
            this.avisosNoRevisados = [];
          }
        },
        (error) => { console.log('Error', error); });
    }
    else {
      if (window.location.href.indexOf('auth') == -1) {
        this._router.navigate(['login']);
      }
    }
  }

  cargarAvisosUsuarioPorUsuarioNoRev(id: number) {
    this._ns.avisosUsuariosPorUsuarioRevisado(id, 0).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.totalAvisosNoRevisados = result.data.length;
          this.avisosNoRevisados = result.data;
        }
        else {
          this.avisosNoRevisados = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

}
